<div class="container">
  <lib-entity-videos-section
    [type]="entityType"
    [user]="userService.currentUser"
  >
  </lib-entity-videos-section>
</div>
